import { render, staticRenderFns } from "./nonbindUser.vue?vue&type=template&id=1404c78e&scoped=true"
import script from "./nonbindUser.vue?vue&type=script&lang=js"
export * from "./nonbindUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1404c78e",
  null
  
)

export default component.exports